const Utils = {}

Utils.blues = [
    {
        color: '#D1ECF5',
        textColor: 'black',
        state: 'Lean D',
        key: 'LEAN D'
    },
    {
        color: '#82B7D4',
        textColor: 'black',
        state: 'Likely D',
        key: 'LIKELY D'
    },
    {
        color: 'var(--dem)',
        textColor: 'white',
        state: 'Solid D',
        key: 'SAFE D',
    },
    {
        color: 'var(--dem)',
        textColor: 'white',
        state: 'Solid D',
        key: 'SOLID D',
    },
]
Utils.tossup = [
    {
        color: 'var(--purple)',
        textColor: 'white',
        state: 'Toss Up',
        key: 'TOSSUP'
    },
    {
        color: 'var(--purple)',
        textColor: 'white',
        state: 'Toss Up',
        key: 'TOSS UP',
    },
]
Utils.reds = [
    {
        color: '#FFCFC6',
        textColor: 'black',
        state: 'Lean R',
        key: 'LEAN R'
    },
    {
        color: '#F6887C',
        textColor: 'black',
        state: 'Likely R',
        key: 'LIKELY R'
    },
    {
        color: 'var(--gop)',
        textColor: 'white',
        state: 'Solid R',
        key: 'SAFE R'
    },
    {
        color: 'var(--gop)',
        textColor: 'white',
        state: 'Solid R',
        key: 'SOLID R',
    },
]

Utils.dFlip = {
    color: 'var(--dem)',
    fromColor: 'var(--gop)',
    text: 'Potential R ➔ D Flip',
    gradient: 'linear-gradient(45deg, var(--gop) 0%, var(--gop) 50%, var(--dem) 50%, var(--dem) 100%)',
    value: 1
}

Utils.rFlip = {
    color: 'var(--gop)',
    fromColor: 'var(--dem)',
    text: 'Potential D ➔ R Flip',
    gradient: 'linear-gradient(45deg, var(--dem) 0%, var(--dem) 50%, var(--gop) 50%, var(--gop) 100%)',
    value: -1
}

Utils.colorScale = [...Utils.blues.reverse(), ...Utils.tossup, ...Utils.reds]

Utils.getColorScale = (key) => {
    return Utils.colorScale.find(c => c.key === key)
}

Utils.getFlip = (value) => {
    if (value === 1) {
        return Utils.dFlip
    } else if (value === -1) {
        return Utils.rFlip
    }
}

Utils.debounce = (fn, time) => {
    let timeout

    return function () {
        const functionCall = () => fn.apply(this, arguments)

        clearTimeout(timeout)
        timeout = setTimeout(functionCall, time)
    }
}

export default Utils
